const crearNuevoJson = (nombre, valor) => {
    var obj = {};
    obj[nombre] = valor;
    return obj;
  }

  export default crearNuevoJson;
